import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	refreshApp: {
		id: 'forge-ui-renderers.common.error-panel.refresh-app',
		defaultMessage: 'Refresh app',
		description: 'This text is displayed on a button that lets the user refresh a Forge app.',
	},
});
